var libs = {
    '1012': '地方文献数据库'
}

export function getLibTitle (code) {
    if (libs[code]) {
        return libs[code];
    }

    return '智慧图书馆知识资源发布系统';
}

// export default {
//     getLibTitle
// }
